module.exports = __webpack_public_path__ + "static/2006-layer-1-9ca6358ad66c71f321b004f6ece70846.png";